import styled from 'styled-components';
import { FADE, t } from 'theme';

const HeaderButton = styled.div`
  font-size: 18px;
  cursor: ${props => (props.selected ? 'default' : 'pointer')};
  text-decoration: ${props => (props.selected ? 'underline' : 'none')};
  color: ${props => (props.selected ? t('fg')(props) : t('muted')(props))};
  float: left;
  border-left: 1px solid ${t('rule')};
  margin-left: 10px;
  padding-left: 10px;
  transition: color ${FADE}, border-color ${FADE};
  &:first-child {
    border-left: none;
    margin-left: 0px;
    padding-left: 0px;
  }
  &:hover {
    text-decoration: underline;
    color: ${t('fg')};
  }
`;

export default HeaderButton;
